import { render } from "./KeunggulanCCTV.vue?vue&type=template&id=9831d080"
import script from "./KeunggulanCCTV.vue?vue&type=script&lang=js"
export * from "./KeunggulanCCTV.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__